export const validateCommaEmails = function(emails){
    let valid = true;
    
    let emailList = emails.replace(/\s/g,'').split(",");
    for (var i = 0; i < emailList.length; i++) {
        if(emailNotValid(emailList[i])){
            valid = false;
        }
    }

    return valid;
}

export const emailNotValid = function(email){
    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email == "" || ! regex.test(email);
}